import { Box, CircularProgress } from '@mui/material';
import React, { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Root, OutletWrapper } from './MainLayout.styles';
import { CustomPermission } from '../../../@types';
import { menuData } from '../../../configs/menu';
import { permittedLayouts } from '../../../configs/permissions';
import { useGetUserSystemPermissions } from '../../../queries/user-query';
import { home } from '../../../routes/MainRoutes';
import { Drawer } from '../../molecules/Drawer';
import { ConnectProvider } from '../ConnectProvider';
import { ConnectSecondaryDrawer } from '../ConnectSecondaryDrawer';
import { DispositionDialog } from '../DispositionDialog';

const RouteLoadingFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, p: 6 }}>
    <CircularProgress />
  </Box>
);

export const MainLayout = () => {
  const [permissions, setPermissions] = useState<CustomPermission[]>();
  const [isOutsideClick, setIsOutsideClick] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- pre-existing; `layoutes` holds either [home] (route object) or permittedLayouts() output (MainMenuItem[]) — unifying the types is a separate cleanup.
  let layoutes: any[] = [home];

  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    if (getUserPermissionsQuery.isSuccess && getUserPermissionsQuery.data) {
      setPermissions(getUserPermissionsQuery.data);
    }
  }, [getUserPermissionsQuery.isLoading, getUserPermissionsQuery.isSuccess]);

  if (permissions) {
    layoutes = permittedLayouts(menuData, permissions);
  }

  return (
    <ConnectProvider>
      <Root>
        <Drawer
          menuData={layoutes}
          isOutsideClick={isOutsideClick}
          handleOutsideClick={setIsOutsideClick}
        />
        <OutletWrapper onClick={() => setIsOutsideClick(true)}>
          <Suspense fallback={<RouteLoadingFallback />}>
            <Outlet />
          </Suspense>
        </OutletWrapper>
        <ConnectSecondaryDrawer />
        <DispositionDialog />
      </Root>
    </ConnectProvider>
  );
};
